import React from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  CardText,
  Button,
  Badge
} from "reactstrap";

const promocoes = [
  {
    titulo: "Grupo de Lives",
    descricao:
      "Participe das lives diárias com o Teleco. Estratégias ao vivo, operações reais e muito aprendizado.",
    precoAtual: "GRÁTIS",
    link: "https://t.me/+ftWp5hWBJNc4Yjcx"
  },
  {
    titulo: "Robô de Alertas 1.5X",
    descricao:
      "Ideal para iniciantes. Sinais automáticos de proteção até 1.5X no Aviator.",
    precoOriginal: "R$99,90",
    precoAtual: "R$9,90",
    link: "https://pay.kirvano.com/abb4995b-65c7-43a2-a1f2-fb5e2324bc70"
  },
  {
    titulo: "Tropa VIP do Teleco",
    descricao:
      "Acesso ao grupo fechado com mentorias, sinais exclusivos e acompanhamento diário nas operações.",
    precoOriginal: "R$197,00",
    precoAtual: "R$97,00",
    link: "https://pay.kirvano.com/8e003f31-23c9-425c-b65f-fe3c137dc52c"
  },
  {
    titulo: "Robô de Alertas 10X",
    descricao:
      "Receba sinais com alta probabilidade de multiplicadores acima de 10X diretamente no Telegram.",
    precoOriginal: "R$147,00",
    precoAtual: "R$47,00",
    link: "https://pay.kirvano.com/659ad9bd-f61a-469e-b473-5fa7afd4d63f"
  },
  {
    titulo: "Robô de Alertas 30X",
    descricao:
      "Sinais raros e poderosos. Nosso robô de 30X entrega oportunidades de alavancagem extrema.",
    precoOriginal: "R$297,00",
    precoAtual: "R$67,00",
    link: "https://pay.kirvano.com/5c5d3d7a-04a6-4f6f-b8b1-e4f0d64545cc"
  },
  {
    titulo: "Automahack PRO",
    descricao:
      "Acesso vitálicio com preço único para melhor ferramenta do mercado. AUTOMAHACK PRO.",
    precoOriginal: "R$297,00",
    precoAtual: "R$97,00",
    link: "https://pay.kirvano.com/005cae12-458a-42a3-b8c5-f2d994d84047"
  }
];

const Promocoes = () => {
  return (
    <div className="content promotions">
      <Row className="mb-4">
        <Col xs={12} className="text-center">
          <h2 className="title">Nossas Promoções e Produtos</h2>
          <p>
            Escolha abaixo o produto ideal para seu momento e comece a operar
            com mais confiança!
          </p>
        </Col>
      </Row>

      <Row className="d-flex justify-content-center">
        {promocoes.map((promo, index) => (
          <Col key={index} xs={12} md={6} lg={4} className="mb-4">
            <Card
              className={`h-100 shadow position-relative ${
                promo.disabled ? "disabled-card" : ""
              }`}
            >
              {promo.disabled && (
                <Badge
                  color="warning"
                  className="position-absolute top-0 start-0 m-2"
                >
                  EM BREVE
                </Badge>
              )}
              <CardBody className="d-flex flex-column justify-content-between">
                <CardTitle tag="h4" className="mb-2 fw-bold">
                  {promo.titulo}
                </CardTitle>
                <CardText className="mb-2">{promo.descricao}</CardText>

                <div className="preco-box mb-3">
                  {promo.precoOriginal && (
                    <span className="preco-original">
                      {promo.precoOriginal}
                    </span>
                  )}
                  <span
                    className={`preco-atual ${
                      promo.precoAtual === "GRÁTIS" ? "gratis" : ""
                    }`}
                  >
                    {promo.precoAtual}
                  </span>
                </div>

                <Button
                  color="primary"
                  href={promo.link}
                  target="_blank"
                  className="mt-auto"
                  disabled={promo.disabled}
                >
                  {promo.disabled ? "Indisponível" : "Acessar"}
                </Button>
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default Promocoes;
